import * as React from "react";

import { Container, Medium, Spacer, Title } from "@vestaboard/installables";

export const MirrorInstallableSettings: React.FC = () => {
  return (
    <>
      <Container>
        <div
          style={{
            textAlign: "center",
          }}
        >
          <Spacer size="large" />
          <Title>We've improved Mirroring based on your feedback.</Title>
          <Spacer size="medium" />
          <Medium color="#FFF">
            The new version is more reliable, easier to manage and no longer
            requires adding a channel.
          </Medium>
          <Spacer size="large" />
          <Medium color="#FFF">
            <strong>⚠️ This version is being retired.</strong>
          </Medium>
          <Spacer size="small" />
          <Medium color="#FFF">
            To keep your displays in sync, switch to the{" "}
            <a
              href="https://platform.vestaboard.com/deeplink/settings/publish"
              rel="noopener noreferrer"
              target="_blank"
              style={{
                color: "#FFF",
                textDecoration: "underline",
              }}
            >
              new Publish
            </a>{" "}
            section now in beta.
          </Medium>
          <Spacer size="large" />
          <Medium color="#FFF">
            <strong>Need help getting started?</strong>
          </Medium>
          <Medium color="#FFF">
            <a
              href="https://www.vestaboard.com/meetings/vestaboard"
              rel="noopener noreferrer"
              target="_blank"
              style={{
                color: "#FFF",
                textDecoration: "underline",
              }}
            >
              Book time with our team
            </a>
            .
          </Medium>
          <Spacer size="large" />
        </div>
      </Container>
    </>
  );
};
